if (!customElements.get('card-images-products-drawer')) {
  customElements.define(
    'card-images-products-drawer',
    class CardImagesProductsDrawer extends ModalComponent {
      constructor() {
        super();
        this.popupBody = this.querySelector('[data-card-images-popup-body]');
        this.popupTitle = this.querySelector('[data-card-images-popup-title]');
        this.addAllButton = this.querySelector('[data-card-images-popup-add-all]');

        this.sourceCard = null;
        this.onAddAllClick = this.handleAddAllClick.bind(this);
        this.onOpenTriggerClick = this.handleOpenTriggerClick.bind(this);
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();
        if (this.addAllButton) {
          this.addAllButton.addEventListener('click', this.onAddAllClick);
        }
        document.addEventListener('click', this.onOpenTriggerClick);
      }

       prepareToShow() {
        super.prepareToShow();
        document.body.classList.add('modal-show');
      }

      handleAfterHide() {
        super.handleAfterHide();
        document.body.classList.remove('modal-show');
      }

      
      disconnectedCallback() {
        if (this.addAllButton) {
          this.addAllButton.removeEventListener('click', this.onAddAllClick);
        }
        document.removeEventListener('click', this.onOpenTriggerClick);
        super.disconnectedCallback();
      }

      handleOpenTriggerClick(event) {
        const trigger = event.target.closest(`[data-card-images-open="${this.id}"]`);
        if (!trigger) return;
        event.preventDefault();

        const sourceCard = trigger.closest('.card-images-product-source');
        if (!sourceCard) return;

        this.sourceCard = sourceCard;
        this.updatePopupContentFromSource(sourceCard);
        this.show(trigger);
      }

      updatePopupContentFromSource(sourceCard) {
        const template = sourceCard.querySelector('template[data-card-images-products-template]');
        const dataNode = sourceCard.querySelector('[data-card-images-variants]');

        if (this.popupBody) {
          this.popupBody.innerHTML = template ? template.innerHTML : '';
        }

        if (dataNode && this.addAllButton) {
          const variants = dataNode.dataset.cardImagesVariants || '';
          const total = dataNode.dataset.cardImagesTotal || '';
          const title = dataNode.dataset.cardImagesTitle || 'Products';

          this.addAllButton.dataset.variantIds = variants;
          this.addAllButton.textContent = total ? `Shop all • ${total}` : 'Shop all';
          if (this.popupTitle) {
            this.popupTitle.childNodes[0].nodeValue = title;
          }
        }
      }

      async handleAddAllClick(event) {
        event.preventDefault();
        if (!this.addAllButton) return;

        const variantIds = (this.addAllButton.dataset.variantIds || '')
          .split(',')
          .map((id) => Number(id.trim()))
          .filter((id) => Number.isInteger(id) && id > 0);

        if (!variantIds.length) return;

        const items = variantIds.map((id) => ({ id, quantity: 1 }));

        this.addAllButton.classList.add('btn--loading');
        this.addAllButton.setAttribute('aria-disabled', 'true');

        try {
          const addResponse = await fetch(`${FoxTheme.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          const addResult = await addResponse.json();
          if (!addResponse.ok || addResult.status) {
            throw new Error(addResult.description || 'Unable to add products to cart.');
          }

          this.hide();
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { open: true },
            })
          );
        } catch (error) {
          alert(error.message || 'Unable to add products to cart.');
        } finally {
          this.addAllButton.classList.remove('btn--loading');
          this.addAllButton.removeAttribute('aria-disabled');
        }
      }
    }
  );
}
